import { AlternativeFilterReadModel, CompoundFilterReadModel } from "@Alternatives/AlternativesViews/Domain/readmodels";

export class AlternativesViewsUtils
{
    static BuildFilterReadModel(type: string): AlternativeFilterReadModel
    {
        switch (type)
        {
            case "And":
            case "Or":
                return this.BuildCompoundFilter(type);

            case "PropertyEq":
            case "PropertyNotEq":
            case "PropertyLt":
            case "PropertyLte":
            case "PropertyGt":
            case "PropertyGte":
            case "PropertyIsKnown":
            case "PropertyIsUnknown":
            case "PropertyContains":
                return this.BuildPropertyFilter(type);

            case "StatusIn":
            case "StatusNotIn":
                return this.BuildStatusFilter(type);

            case "MemberOf":
            case "NotMemberOf":
                return this.BuildMemberFilter(type);

            default: return null;
        }
    }

    static BuildCompoundFilter(type: string)
    {
        const filter = new CompoundFilterReadModel();
        filter.Type = type;
        filter.Filters = [];
        filter.Data = [];
        filter.IsCompoundFilter = true;
        filter.IsMemberFilter = false;
        filter.IsStatusFilter = false;
        filter.IsPropertyFilter = false;
        return filter;
    }

    static BuildStatusFilter(type: string)
    {
        const filter = new AlternativeFilterReadModel();
        filter.Type = type;
        filter.Data = [];
        filter.IsCompoundFilter = false;
        filter.IsMemberFilter = false;
        filter.IsStatusFilter = true;
        filter.IsPropertyFilter = false;
        return filter;
    }

    static BuildPropertyFilter(type: string)
    {
        const filter = new AlternativeFilterReadModel();
        filter.Type = type;
        filter.Data = { Name: null, Value: null };
        filter.IsCompoundFilter = false;
        filter.IsMemberFilter = false;
        filter.IsStatusFilter = false;
        filter.IsPropertyFilter = true;
        return filter;
    }

    static BuildMemberFilter(type: string)
    {
        const filter = new AlternativeFilterReadModel();
        filter.Type = type;
        filter.Data = [];
        filter.IsCompoundFilter = false;
        filter.IsMemberFilter = true;
        filter.IsStatusFilter = false;
        filter.IsPropertyFilter = false;
        return filter;
    }
}